import React, {useEffect, useRef, useState} from 'react';
import styled from "styled-components";
import {colors} from "../../maps/colors";
import TextField from "@mui/material/TextField";

const CategoriesWrapperStyled = styled.div`

`;

const CategoriesWidthStyled = styled.div`

`;

const TitleWrapperStyled = styled.div`
    display: grid;
    grid-template-columns: auto 1fr;
    justify-content: center;
    align-items: center;
    grid-gap: 15px;
`;

const CategoriesItemsStyled = styled.div`
    display: flex;
    overflow-x: auto;
    padding-bottom: 13px;
`;

const CategoriesItemStyled = styled.div`
    border-radius: 5px;
    border: 1px solid ${colors.GRAY2};
    padding: 6px 8px;
    cursor: pointer;

    &.active {
        border-color: ${colors.GREEN};
        background: ${colors.LIGHT_GREEN};
    }

    flex-shrink: 0;
    height: auto;
    margin-right: 10px;
`;

const CategoriesShow = ({items, selectedItemId, selectItemHandle}) => {
    const stage = useRef(null);

    const [width, s_width] = useState(0);
    const [filterValue, s_filterValue] = useState("");

    useEffect(() => {
        if (stage.current && stage.current.offsetWidth) {
            s_width(stage.current.offsetWidth);
        }
    }, [stage.current?.offsetWidth]);

    const filteredItem = items.filter((item) => item.name.toLowerCase().includes(filterValue.toLowerCase()));

    return (
        <CategoriesWrapperStyled ref={stage}>
            <CategoriesWidthStyled style={{width}}>
                <TitleWrapperStyled>
                    <h3>Categories</h3>
                    <TextField
                        autoComplete={"off"}
                        sx={{width: '250px'}}
                        value={filterValue}
                        onChange={(e) => {
                            s_filterValue(e.target.value);
                        }}
                        id="outlined-basic" label="Filter" variant="outlined" size="small"/>
                </TitleWrapperStyled>
                <CategoriesItemsStyled>
                    {filteredItem.map((item) => {

                        const isSelected = selectedItemId === item._id;

                        return (
                            <CategoriesItemStyled
                                className={isSelected ? "active" : ""}
                                onClick={() => selectItemHandle(item._id)}
                                key={item._id}>
                                {item.name} ({item.count || 0})
                            </CategoriesItemStyled>
                        );
                    })}
                </CategoriesItemsStyled>
            </CategoriesWidthStyled>
        </CategoriesWrapperStyled>
    );
};

export default CategoriesShow;